// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3hL1T","colMin":"styles_colMin__1PJTP","colCheckbox":"styles_colCheckbox__VCWi8"};